// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8fad6581","455":"6ef57668","977":"b22c1539"}[chunkId] + ".chunk.js";
};